import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import LanguagePicker from "../Header/LanguagePicker.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useUser } from "../../../contexts/userContext/userContext.js";

export const BottomSection = () => {
  const { getTextByKey, getLanguageCulture } = useContent();
  const { isLoggedIn } = useUser();

  return (
    <div className="footer-bottom-section">
      <LinkToNewTab page="home">
        <Image name="logo-footer" ext="png" title="JUMBOmail" alt="JUMBOmail" />
      </LinkToNewTab>
      <div className="flex-row">
        <a
          className="footer-gray-link"
          href={`/${getLanguageCulture().substring(
            0,
            2
          )}/features/downloadfiles`}
        >
          {getTextByKey("file-sharing")}
        </a>
        <span className="footer-link-divider">|</span>
        <a
          className="footer-gray-link"
          href={`/${getLanguageCulture().substring(
            0,
            2
          )}/features/sendbigfiles`}
        >
          {getTextByKey("send-large-files")}
        </a>
        <span className="footer-link-divider">|</span>
        <a
          className="footer-gray-link"
          href={`/${getLanguageCulture().substring(0, 2)}/features/filesvault`}
        >
          {getTextByKey("file-hosting")}
        </a>
        {navigator.userAgent === "ReactSnap" || !isLoggedIn() ? null : (
          <div>
            <LanguagePicker className="bottom-language"></LanguagePicker>
          </div>
        )}
      </div>
    </div>
  );
};
